var formNewsletterSubmit;

document.addEventListener('DOMContentLoaded', function() {
    window.imNotARobot = function() {
        document.querySelectorAll('.g-recaptcha-error').forEach(function(item) {
            item.remove();
        });
    };

    window.formNewsletterSubmit = function() {
        var newsletter = document.querySelector('.js-newsletterForm');

        var response = grecaptcha.getResponse();
        if (response.length == 0) {
            // reCaptcha not verified
            var label = document.createElement('label');
            label.innerHTML = "Please confirm you're not a robot";
            label.classList.add('g-recaptcha-error', 'error');
            document.querySelectorAll('.g-recaptcha').forEach(function(item) {
                item.appendChild(label);
            });
            return false;
        } else {
            // reCaptcha verified
            // make the post call
            var xhr = new XMLHttpRequest();
            xhr.open('POST', window.location.origin + '/wp-content/themes/asbestos/ajax/signup.php');
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.onload = function() {
                if (xhr.status === 200) {
                    newsletter.querySelector('.c-form__group').style.display = 'none';
                    newsletter.querySelector('.c-disclaimer--form').style.display = 'none';
                    newsletter.querySelector('.c-form__submit').style.display = 'none';
                    newsletter.querySelector('.c-form__heading').textContent = 'Thank You!';
                    newsletter.querySelector('.c-form__description').textContent = 'You will now receive updates from Asbestos.com.';
                }
            };
            var fullName = encodeURIComponent(newsletter.querySelector('input[name=full_name]').value);
            var email = encodeURIComponent(newsletter.querySelector('input[name=email]').value);
            var data = 'destination=https://api.createsend.com/api/v3.2/subscribers/775c2ec121b40e913748ad2d375d9b0b.json&name=' + fullName + '&email=' + email;
            xhr.send(data);

            return false;
        }
    };
});
